module.exports = __webpack_public_path__ + "advisory-8c397925/kuendigung-fe6ef5b738e1ee280f14fd2919dee60a.jpeg";